module.exports = __webpack_public_path__ + "static/media/BIFI-logo.d2991da1.svg";